const CURRENCY_ALIASES = {
    'جنيه': 'EGP',
    'جنيه مصري': 'EGP',
    'ج.م': 'EGP',
    'ج.م.': 'EGP',
    'ج.م.‏': 'EGP',
    'egyptian pound': 'EGP',
};

const normalizeLocale = (locale) => {
    if (!locale) {
        return 'en';
    }

    const lower = String(locale).toLowerCase();
    if (lower === 'ar' || lower.startsWith('ar-')) {
        return 'ar-EG';
    }

    return locale;
};

const normalizeCurrencyCode = (currency) => {
    if (!currency) {
        return 'USD';
    }

    const trimmed = String(currency).trim();
    if (/^[A-Za-z]{3}$/.test(trimmed)) {
        return trimmed.toUpperCase();
    }

    return CURRENCY_ALIASES[trimmed] ?? CURRENCY_ALIASES[trimmed.toLowerCase()] ?? trimmed.toUpperCase();
};

const formatCurrency = (amount, currency = 'USD', locale = 'en') => {
    const value = Number(amount ?? 0);
    const currencyCode = normalizeCurrencyCode(currency);
    const normalizedLocale = normalizeLocale(locale);

    try {
        // For English locales, show numeric value then currency code (e.g. "100.00 EGP")
        if (String(normalizedLocale).toLowerCase().startsWith('en')) {
            const numberFormatter = new Intl.NumberFormat(normalizedLocale, {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            return `${numberFormatter.format(value)} ${currencyCode}`.trim();
        }

        const formatter = new Intl.NumberFormat(normalizedLocale, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        return formatter.format(value);
    } catch (e) {
        if (String(normalizedLocale).toLowerCase().startsWith('en')) {
            return `${value.toFixed(2)} ${currencyCode}`.trim();
        }

        try {
            const symbol = new Intl.NumberFormat('ar-EG', {
                style: 'currency',
                currency: currencyCode,
            })
                .formatToParts(0)
                .find((part) => part.type === 'currency')?.value ?? currencyCode;

            return `${symbol} ${value.toFixed(2)}`;
        } catch {
            return `${currencyCode} ${value.toFixed(2)}`;
        }
    }
};

export default formatCurrency;
